var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.navigation
  }, [_c('div', {
    class: _vm.theme.logo
  }, [_c('v-router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('v-logo', {
    attrs: {
      "white": ""
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.create
  }, [_c('v-router-link', {
    attrs: {
      "to": {
        name: 'requestProducts'
      }
    }
  }, [_c('v-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("\n                Создать запрос\n            ")])], 1)], 1), _vm._v(" "), _c('div', {
    class: _vm.theme.links
  }, [(_vm.products.length == 0) ? _c('v-spinner', {
    attrs: {
      "transparent": "",
      "green": "",
      "block": ""
    }
  }) : _c('div', [_vm._l((_vm.routes), function(route, index) {
    return _c('v-router-link', {
      key: index,
      class: _vm.theme.link,
      attrs: {
        "exact-active-class": route.path === '/' ? _vm.theme.isActiveLink : undefined,
        "active-class": route.path !== '/' ? _vm.theme.isActiveLink : undefined,
        "to": route.path
      }
    }, [_c('v-font-icon', {
      attrs: {
        "inherit": ""
      }
    }, [_vm._v(_vm._s(route.meta.icon))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "margin",
        rawName: "v-margin.left",
        value: (2),
        expression: "2",
        modifiers: {
          "left": true
        }
      }]
    }, [_vm._v(_vm._s(route.meta.title))])], 1)
  }), _vm._v(" "), _c('v-link', {
    class: _vm.theme.link,
    attrs: {
      "active-class": _vm.theme.isActiveLink,
      "to": 'https://t.me/lkexbico_bot'
    }
  }, [_c('v-font-icon', {
    attrs: {
      "inherit": ""
    }
  }, [_vm._v("send")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "margin",
      rawName: "v-margin.left",
      value: (2),
      expression: "2",
      modifiers: {
        "left": true
      }
    }]
  }, [_vm._v("Телеграм бот")])], 1)], 2), _vm._v(" "), (_vm.refinanceIntegrated) ? _c('v-link', {
    class: _vm.theme.link,
    attrs: {
      "to": "/refinance/analysis"
    }
  }, [_c('v-font-icon', {
    attrs: {
      "inherit": ""
    }
  }, [_vm._v("assessment")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "margin",
      rawName: "v-margin.left",
      value: (2),
      expression: "2",
      modifiers: {
        "left": true
      }
    }]
  }, [_vm._v("Анализ КИ")])], 1) : _vm._e()], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04f7bb18","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/Navigation/Navigation.vue
// module id = 1190
// module chunks = 0